import { STANDARD_BRANCH } from '@festina-life/api'
import { useTranslate } from '@festina-life/ui/hooks'
import { FilterCheckbox } from '@festina-life/ui/listsAndTables'
import { useRef } from 'react'

import { Attribute } from '../../components/attribute/Attribute'
import { OperationApproval } from '../../components/operationApproval/OperationApproval'
import { OperationViewerTopBar } from '../../components/operationViewerTopBar/OperationViewerTopBar'
import { ParameterValuesExportButton } from '../../components/parameterValuesExportButton/ParameterValuesExportButton'
import { useLayoutContext } from '../../context/layoutContext'
import { useParameterContext } from '../../context/parameterContext'
import { useNavigationParams } from '../../system/useNavigationParams'
import { ParameterTransferButton } from './ParameterTransferButton'
import { ParameterViewPreferencesMenu } from './ParameterViewPreferencesMenu'

export const ParameterViewerTopBar = () => {
  const translate = useTranslate()
  const { preferences, onChangeView } = useLayoutContext()
  const { branch } = useNavigationParams()
  const userDefinedFlattenedMode = useRef(preferences.parameters.isFlattened)
  const { parameterDefinitionOperation } = useParameterContext()
  const isDraftParameterDefinition = parameterDefinitionOperation?.isDraft
  const changesetKey =
    parameterDefinitionOperation?.changesetHistory?.changesetKey
  const operationKey =
    parameterDefinitionOperation?.internalOperation.operationKey
  const approvalSet = operationKey
    ? parameterDefinitionOperation?.changesetHistory?.approvalSets?.find(
        (approvalSet) => approvalSet?.operationKeys?.includes(operationKey),
      )
    : undefined

  return (
    <OperationViewerTopBar className="justify-between">
      <div className="flex flex-row gap-x-4">
        <FilterCheckbox
          label={translate('templateViewer.topBar.option.flatten')}
          id="flatten"
          checked={preferences.parameters.isFlattened}
          disabled={preferences.parameters.isTimeSeriesMode}
          onChange={() => {
            userDefinedFlattenedMode.current =
              !preferences.parameters.isFlattened

            onChangeView({
              ...preferences,
              parameters: {
                ...preferences.parameters,
                isFlattened: userDefinedFlattenedMode.current,
              },
            })
          }}
        />
        <FilterCheckbox
          label={translate('templateViewer.topBar.option.timeSeriesMode')}
          id="timeSeriesMode"
          checked={preferences.parameters.isTimeSeriesMode}
          onChange={() => {
            const nextTimeSeriesMode = !preferences.parameters.isTimeSeriesMode

            onChangeView({
              ...preferences,
              parameters: {
                ...preferences.parameters,
                isFlattened:
                  nextTimeSeriesMode || userDefinedFlattenedMode.current,
                isTimeSeriesMode: !preferences.parameters.isTimeSeriesMode,
              },
            })
          }}
        />
        <ParameterViewPreferencesMenu />
      </div>
      <div className="flex flex-row gap-x-2 items-center">
        {!!parameterDefinitionOperation?.internalOperation.entity
          ?.isExtrinsic && (
          <Attribute>{translate('attribute.extrinsic')}</Attribute>
        )}
        {!isDraftParameterDefinition &&
          branch !== STANDARD_BRANCH &&
          changesetKey &&
          operationKey && (
            <OperationApproval
              actions={[
                {
                  action: 'create',
                  userId: null, // FIXME: Add creator once it's available on the operation
                  actionTime: null, // FIXME: Add creation time once it's available on the operation
                },
                {
                  action: 'approve',
                  userId: approvalSet?.approverUserId,
                  actionTime: approvalSet?.approvalTime,
                },
              ]}
              changesetKey={changesetKey}
              operationKey={operationKey}
            />
          )}
        <ParameterTransferButton />
        {branch === STANDARD_BRANCH && <ParameterValuesExportButton />}
      </div>
    </OperationViewerTopBar>
  )
}
